(function () {
  var headers = document.querySelectorAll('.oddit-header');
  if (!headers.length) return;

  headers.forEach(function (header) {
    initHeader(header);
  });

  function initHeader(header) {
    var menuToggle = header.querySelector('[data-mobile-menu-toggle]');
    var drawer = header.querySelector('[data-mobile-menu]');

    function openDrawer() {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('oddit-mobile-menu-open');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('oddit-mobile-menu-open');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    }

    if (menuToggle) {
      menuToggle.addEventListener('click', function () {
        var expanded = menuToggle.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
    }

    if (drawer) {
      var closers = drawer.querySelectorAll('[data-mobile-menu-close]');
      closers.forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
          closeDrawer();
        }
      });
    }

    var cartToggles = header.querySelectorAll('[data-cart-toggle]');
    for (var i = 0; i < cartToggles.length; i++) {
      cartToggles[i].addEventListener('click', function () {
        if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
          closeDrawer();
        }
        if (window.OdditCartDrawer && typeof window.OdditCartDrawer.open === 'function') {
          window.OdditCartDrawer.open();
        }
      });
    }
  }

  document.addEventListener('cart:updated', function (e) {
    if (!e || !e.detail || !e.detail.cart) return;
    var cart = e.detail.cart;
    var badges = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = cart.item_count;
      badges[i].style.display = cart.item_count > 0 ? '' : 'none';
    }
  });
})();